// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as SterlingIcons$LiveRoom from "../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";

var spacer = Curry._1(Css.style, {
      hd: Css.width(Css.px(8)),
      tl: /* [] */0
    });

var infoClicker = Curry._1(Css.style, {
      hd: Css.cursor("pointer"),
      tl: {
        hd: Css.display("flex"),
        tl: {
          hd: Css.flexDirection("row"),
          tl: {
            hd: Css.fontWeight({
                  NAME: "num",
                  VAL: 600
                }),
            tl: {
              hd: Css.fontSize(Css.px(13)),
              tl: {
                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey90_nohashtag)),
                tl: {
                  hd: Css.marginBottom(Css.px(20)),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var phoneNumber = Curry._1(Css.style, {
      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGold60_nohashtag)),
      tl: /* [] */0
    });

function InfoClicker(props) {
  var onClick = props.onClick;
  var sub = props.sub;
  var title = props.title;
  var kind = props.kind;
  var kind$1 = kind !== undefined ? kind : /* Phone */1;
  var title$1 = title !== undefined ? title : "";
  var sub$1 = sub !== undefined ? sub : "";
  var onClick$1 = onClick !== undefined ? onClick : (function (param) {
        
      });
  var link = kind$1 ? "tel:" + sub$1 : "mailto:" + sub$1;
  return React.createElement("div", {
              className: infoClicker,
              onClick: (function (param) {
                  Curry._1(onClick$1, undefined);
                })
            }, kind$1 ? React.createElement(SterlingIcons$LiveRoom.Collection.Mobile24.make, {}) : React.createElement(SterlingIcons$LiveRoom.Collection.Email24.make, {}), React.createElement("div", {
                  className: spacer
                }), React.createElement("div", undefined, React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.marginBottom(Css.px(4)),
                            tl: /* [] */0
                          })
                    }, title$1), React.createElement("div", {
                      className: sub$1
                    }, React.createElement("a", {
                          className: phoneNumber,
                          href: link
                        }, sub$1))));
}

var make = InfoClicker;

export {
  spacer ,
  infoClicker ,
  phoneNumber ,
  make ,
}
/* spacer Not a pure module */
